<template>
    <div>
        <div
            v-if="variable.module == 'values'"
            :class="getClass(validations.category_id)"
        >
            <Categories
                :selected="variable.category_id"
                :state="validations.category_id"
                @change="$emit('update', 'category_id', $event)"
            />
        </div>
        <div
            v-if="variable.module == 'target'"
            :class="getClass(targetIsValid)"
        >
            <TargetResultType
                :state="validations.result_type"
                :selected="variable.result_type"
                @change="$emit('update', 'result_type', $event)"
            />
            <LevelsWeight
                :validations="validations"
                :team_weight="variable.team_weight"
                :unit_weight="variable.unit_weight"
                :personal_weight="variable.personal_weight"
                @update="(level, value) => $emit('update', level, value)"
            />
        </div>
    </div>
</template>
<script>
import Categories from './components/Categories'
import LevelsWeight from './components/LevelsWeight'
import TargetResultType from './components/TargetResultType'
export default {
    components: { Categories, TargetResultType, LevelsWeight },
    props: {
        variable: {
            type: Object,
            required: true,
        },
        validations: {
            type: Object,
            required: true,
        },
    },
    computed: {
        targetIsValid() {
            const resultTypeIsValid = this.validations.result_type !== false
            const weightsAreValid = [
                'personal_weight',
                'team_weight',
                'unit_weight',
            ].every(key => this.validations[key].isValid !== false)

            return weightsAreValid && resultTypeIsValid
        },
    },
    methods: {
        getClass(isValid) {
            const base = 'border-left pl-2 '
            return isValid === false ? base + 'invalid' : base
        },
    },
}
</script>
